import React, { memo, useEffect } from 'react'
import ShakaPlayer from 'shaka-player-react'
import 'shaka-player/dist/controls.css'
import styled from '@emotion/styled'

import { isMediaTypeAudio } from '../../../util/media.helpers'
import { Box } from '@mui/material'

const MediaPlayer = ({ mediaType, ...restProps }) => {
  useEffect(() => {
    if (isMediaTypeAudio(mediaType)) {
      const fullScreenButton = document.querySelector(
        '.shaka-video-container .shaka-fullscreen-button'
      )
      if (fullScreenButton) {
        fullScreenButton.remove()
      }
    }
    const settingsMenu = document.querySelector(
      '.shaka-video-container .shaka-overflow-menu-button'
    )
    if (settingsMenu) {
      settingsMenu.remove()
    }
  }, [mediaType])
  return (
    <Box sx={{ width: '100%', aspectRatio: '1/1' }}>
      <ShakaPlayerContainer {...restProps} />
    </Box>
  )
}

export default memo(MediaPlayer)

// const MediaPlayerContainer = styled.div`
//   ${CSS_POSITION_RELATIVE};
//   ${CSS_FULL_WIDTH};
// `

const ShakaPlayerContainer = styled(ShakaPlayer)`
  .shaka-server-side-ad-container {
    border-radius: 16px;
  }
  .shaka-scrim-container {
    border-radius: 16px;
  }
  .shaka-controls-container {
    border-width: 1px;
    border-radius: 17px;
  }
  video {
    border-radius: 16px;
  }
`
